/**
 * Rewards page: regroup Stamped ways-to-earn campaigns after Stamped finishes rendering.
 * Icons are applied in CSS from the Font Awesome class already on each campaign.
 */
(function () {
  var GROUPS = [
    {
      key: 'shopping',
      label: 'Shopping & Reviews',
      events: ['uploadVideo', 'uploadPhoto', 'writeReview', 'submitAnswer', 'amountSpent']
    },
    {
      key: 'account',
      label: 'Account & Rewards',
      events: ['subscribeNewsletter', 'createAccount', 'celebrateBirthday']
    },
    {
      key: 'social',
      label: 'Social Engagement',
      events: ['youTubeSubscribe', 'twitterFollow', 'facebookLike', 'instagramFollow']
    }
  ];

  var COPY = {
    uploadVideo: { title: 'Upload a Video Review' },
    uploadPhoto: { title: 'Submit a Photo Review' },
    writeReview: { title: 'Write a Product Review' },
    submitAnswer: { title: 'Answer a Product Question' },
    amountSpent: { title: 'Spend on Purchases', value: '1 Point per $1 Spent' },
    subscribeNewsletter: { title: 'Subscribe to Our Newsletter' },
    createAccount: { title: 'Create an Account' },
    celebrateBirthday: { title: 'Celebrate Your Birthday' },
    youTubeSubscribe: { title: 'Subscribe on Youtube' },
    twitterFollow: { title: 'Follow Us on X' },
    facebookLike: { title: 'Like Us on Facebook' },
    instagramFollow: { title: 'Follow Us on Instagram' }
  };

  var ICONS = {
    shopping: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M4 4h2.2l.5 1.6H20l-1.7 7.6a2 2 0 0 1-2 1.6H9.2a2 2 0 0 1-1.9-1.4L5.4 6H4V4zm5.2 12.2a2.1 2.1 0 1 0 0 4.2 2.1 2.1 0 0 0 0-4.2zm8 0a2.1 2.1 0 1 0 0 4.2 2.1 2.1 0 0 0 0-4.2z"/></svg>',
    account: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 12a4.2 4.2 0 1 0-4.2-4.2A4.2 4.2 0 0 0 12 12zm0 2c-4.3 0-8 2.1-8 4.6V21h16v-2.4c0-2.5-3.7-4.6-8-4.6z"/></svg>',
    social: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="18" cy="5" r="2.4" fill="currentColor"/><circle cx="6" cy="12" r="2.4" fill="currentColor"/><circle cx="18" cy="19" r="2.4" fill="currentColor"/><path d="M8.2 11.1 15.6 6.7M8.2 12.9l7.4 4.4" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round"/></svg>'
  };

  var VIP_TIERS = {
    Member: {
      key: 'member',
      order: 0,
      fallbackRequirement: 'Start earning rewards right away',
      tagline: 'Simple rewards for every shopper'
    },
    Insider: {
      key: 'insider',
      order: 1,
      tagline: 'Unlock even more value'
    },
    VIP: {
      key: 'vip',
      order: 2,
      tagline: 'Our highest level of rewards'
    }
  };

  var timer = null;
  var enhancing = false;
  var vipTimer = null;
  var vipEnhancing = false;
  var spendTimer = null;
  var spendEnhancing = false;
  var pollCount = 0;

  function findWidget() {
    return document.querySelector('#stamped-rewards-widget[data-widget-type="rewards-earnings-v2"], [data-widget-type="rewards-earnings-v2"]');
  }

  function readyItem(item) {
    var id = item.getAttribute('data-campaign-id') || '';
    var eventName = item.getAttribute('data-campaign-event') || '';
    return id && eventName && id.indexOf('{') === -1 && eventName.indexOf('{') === -1;
  }

  function listItems(list) {
    return Array.prototype.filter.call(list.children, function (node) {
      return node.nodeType === 1 && node.classList.contains('stamped-rewards-widget-item');
    });
  }

  function earningsList(widget) {
    var host = widget.querySelector('.stamped-rewards-widget-campaigns-earnings');
    if (!host) return null;
    var lists = host.querySelectorAll('ul.stamped-rewards-earnings');
    var i;
    for (i = 0; i < lists.length; i++) {
      if (!lists[i].classList.contains('esn-earn__grid')) return lists[i];
    }
    return null;
  }

  function needsEnhance(widget) {
    if (!widget) return false;
    var list = earningsList(widget);
    if (!list) return false;
    var items = listItems(list);
    var i;
    for (i = 0; i < items.length; i++) {
      if (readyItem(items[i])) return true;
    }
    return false;
  }

  function applyCopy(item) {
    var copy = COPY[item.getAttribute('data-campaign-event')];
    if (!copy) return;
    var title = item.querySelector('.stamped-rewards-widget-campaign-title');
    var value = item.querySelector('.stamped-rewards-widget-campaign-value');
    if (copy.title && title) title.textContent = copy.title;
    if (copy.value && value) value.textContent = copy.value;
  }

  function groupHead(group) {
    var head = document.createElement('div');
    head.className = 'esn-earn__group-head';

    var pill = document.createElement('span');
    pill.className = 'esn-earn__pill';
    pill.innerHTML = (ICONS[group.key] || '') + '<span>' + group.label + '</span>';

    var rule = document.createElement('span');
    rule.className = 'esn-earn__rule';
    rule.setAttribute('aria-hidden', 'true');

    head.appendChild(pill);
    head.appendChild(rule);
    return head;
  }

  function enhance(widget) {
    var list = earningsList(widget);
    var items = listItems(list);
    var byEvent = {};
    var used = {};
    var i;

    for (i = 0; i < items.length; i++) {
      if (!readyItem(items[i])) continue;
      applyCopy(items[i]);
      byEvent[items[i].getAttribute('data-campaign-event')] = items[i];
    }

    var host = widget.querySelector('.stamped-rewards-widget-campaigns-earnings');
    var previous = host.querySelector('.esn-earn__groups');
    if (previous) previous.remove();

    var groups = document.createElement('div');
    groups.className = 'esn-earn__groups';

    GROUPS.forEach(function (group) {
      var section = document.createElement('section');
      section.className = 'esn-earn__group esn-earn__group--' + group.key;
      section.appendChild(groupHead(group));

      var grid = document.createElement('ul');
      grid.className = 'esn-earn__grid';

      group.events.forEach(function (eventName) {
        var item = byEvent[eventName];
        if (!item) return;
        used[eventName] = true;
        grid.appendChild(item);
      });

      if (!grid.children.length) return;
      section.appendChild(grid);
      groups.appendChild(section);
    });

    var extras = document.createElement('ul');
    extras.className = 'esn-earn__grid';
    Object.keys(byEvent).forEach(function (eventName) {
      if (used[eventName]) return;
      extras.appendChild(byEvent[eventName]);
    });
    if (extras.children.length) {
      var extraSection = document.createElement('section');
      extraSection.className = 'esn-earn__group esn-earn__group--more';
      extraSection.appendChild(extras);
      groups.appendChild(extraSection);
    }

    if (!groups.children.length) return;

    host.appendChild(groups);
    widget.classList.add('esn-rewards-ready');
  }

  function run() {
    timer = null;
    if (enhancing) {
      schedule();
      return;
    }
    var widget = findWidget();
    if (!needsEnhance(widget)) return;
    enhancing = true;
    try {
      enhance(widget);
    } catch (error) {
      window.setTimeout(schedule, 500);
    } finally {
      enhancing = false;
    }
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(run, 400);
  }

  function watch(widget) {
    if (!widget || widget.dataset.esnWatching === 'true') return;
    widget.dataset.esnWatching = 'true';
    var observer = new MutationObserver(function () {
      if (!enhancing) schedule();
    });
    observer.observe(widget, { childList: true, subtree: true });
    schedule();
  }

  function findVipWidget() {
    return document.querySelector('[data-widget-type="rewards-vip-tiers"]');
  }

  function tierName(cell) {
    var span = cell.querySelector('.description span, span');
    return span ? span.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function vipNeedsEnhance(widget) {
    if (!widget) return false;
    var row = widget.querySelector('tr.vip-tier-headers');
    if (!row) return false;
    var cells = row.children;
    var i;
    for (i = 0; i < cells.length; i++) {
      var name = tierName(cells[i]);
      if (name && !cells[i].getAttribute('data-esn-tier')) return true;
    }
    return false;
  }

  function enhanceVip(widget) {
    var row = widget.querySelector('tr.vip-tier-headers');
    if (!row) return;
    var label = null;
    var tiers = [];
    var cells = Array.prototype.slice.call(row.children);
    var i;

    for (i = 0; i < cells.length; i++) {
      var name = tierName(cells[i]);
      if (!name) {
        label = cells[i];
        continue;
      }
      tiers.push(cells[i]);
    }

    tiers.sort(function (a, b) {
      var aTier = VIP_TIERS[tierName(a)] || { order: 99 };
      var bTier = VIP_TIERS[tierName(b)] || { order: 99 };
      return aTier.order - bTier.order;
    });

    if (label) row.appendChild(label);
    tiers.forEach(function (cell) {
      var name = tierName(cell);
      var tier = VIP_TIERS[name] || { key: name.toLowerCase(), tagline: '' };
      var configs = cell.querySelectorAll('.vip-tier-entry-configs-item');
      var hasRequirement = false;
      var c;

      cell.setAttribute('data-esn-tier', tier.key);
      row.appendChild(cell);

      for (c = 0; c < configs.length; c++) {
        if (configs[c].textContent.trim()) hasRequirement = true;
      }
      if (!hasRequirement && tier.fallbackRequirement && configs.length) {
        configs[0].textContent = tier.fallbackRequirement;
      }

      if (tier.tagline && !cell.querySelector('.esn-vip-foot')) {
        var foot = document.createElement('div');
        var rule = document.createElement('span');
        var tagline = document.createElement('p');
        var target = cell.querySelector('.description > div') || cell.querySelector('.description') || cell;
        foot.className = 'esn-vip-foot';
        rule.className = 'esn-vip-rule';
        rule.setAttribute('aria-hidden', 'true');
        tagline.className = 'esn-vip-tagline';
        tagline.textContent = tier.tagline;
        foot.appendChild(rule);
        foot.appendChild(tagline);
        target.appendChild(foot);
      }
    });

    widget.classList.add('esn-vip-ready');
  }

  function runVip() {
    vipTimer = null;
    if (vipEnhancing) {
      scheduleVip();
      return;
    }
    var widget = findVipWidget();
    if (!vipNeedsEnhance(widget)) return;
    vipEnhancing = true;
    try {
      enhanceVip(widget);
    } catch (error) {
      window.setTimeout(scheduleVip, 500);
    } finally {
      vipEnhancing = false;
    }
  }

  function scheduleVip() {
    window.clearTimeout(vipTimer);
    vipTimer = window.setTimeout(runVip, 400);
  }

  function watchVip(widget) {
    if (!widget || widget.dataset.esnVipWatching === 'true') return;
    widget.dataset.esnVipWatching = 'true';
    var observer = new MutationObserver(function () {
      if (!vipEnhancing) scheduleVip();
    });
    observer.observe(widget, { childList: true, subtree: true });
    scheduleVip();
  }

  function findSpendWidget() {
    return document.querySelector('[data-widget-type="rewards-spendings-v2"]');
  }

  var SPEND_OFFERS = {
    '100': { dollars: '$3 off', cost: 100 },
    '250': { dollars: '$8 off', cost: 250 },
    '500': { dollars: '$17 off', cost: 500 },
    '1000': { dollars: '$38 off', cost: 1000 },
    '2500': { dollars: '$100 off', cost: 2500 },
    gift: { dollars: '$38 off', cost: 1000 }
  };

  function rewardKey(item) {
    var existing = item.getAttribute('data-esn-reward');
    if (existing) return existing;
    var type = item.getAttribute('data-campaign-type') || '';
    if (type === 'giftCard') return 'gift';
    var titleNode = item.querySelector('.stamped-rewards-widget-campaign-title');
    var valueNode = item.querySelector('.stamped-rewards-widget-campaign-value');
    var source = ((titleNode && titleNode.textContent) || '') + ' ' + ((valueNode && valueNode.textContent) || '');
    var digits = source.replace(/,/g, '').match(/\b(2500|1000|500|250|100)\b/);
    return digits ? digits[1] : 'other';
  }

  function customerPointBalance() {
    if (!window.StampedFn || typeof window.StampedFn.getDataRewards !== 'function') return null;
    if (typeof window.StampedFn.getLoggedInCustomer === 'function' && !window.StampedFn.getLoggedInCustomer()) return null;
    var data = window.StampedFn.getDataRewards();
    if (!data || !data.points || data.points.points == null || data.points.points === '') return null;
    var number = Number(String(data.points.points).replace(/,/g, ''));
    return isFinite(number) ? number : null;
  }

  function memberIsLoggedIn(widget) {
    if (widget.getAttribute('data-logged-in') === 'true') return true;
    return !!(window.StampedFn && typeof window.StampedFn.getLoggedInCustomer === 'function' && window.StampedFn.getLoggedInCustomer());
  }

  function applySpendCopy(item, key) {
    var offer = SPEND_OFFERS[key];
    if (!offer || item.getAttribute('data-esn-dollars') === 'redeem-line') return;
    var titleNode = item.querySelector('.stamped-rewards-widget-campaign-title');
    var valueNode = item.querySelector('.stamped-rewards-widget-campaign-value');
    if (titleNode) titleNode.textContent = key === 'gift' ? 'Gift Card' : 'Discount';
    if (valueNode) {
      valueNode.textContent = 'Redeem ' + formatPoints(offer.cost) + ' points for ' + offer.dollars;
    }
    item.setAttribute('data-esn-dollars', 'redeem-line');
  }

  function applySpendAccess(widget) {
    var loggedIn = memberIsLoggedIn(widget);
    widget.classList.toggle('esn-spend-authed', loggedIn);
    if (!loggedIn) return true;
    var balance = customerPointBalance();
    if (balance == null) return false;
    var items = spendItems(widget);
    var i;
    for (i = 0; i < items.length; i++) {
      var offer = SPEND_OFFERS[items[i].getAttribute('data-esn-reward')];
      if (!offer) continue;
      var next = balance >= offer.cost ? 'true' : 'false';
      if (items[i].getAttribute('data-esn-affordable') !== next) {
        items[i].setAttribute('data-esn-affordable', next);
      }
    }
    return true;
  }

  function spendItems(widget) {
    var list = widget.querySelector('.stamped-rewards-widget-campaigns-spendings-spend > ul.stamped-rewards-spendings');
    if (!list) return [];
    return Array.prototype.filter.call(list.children, function (node) {
      return node.nodeType === 1 && node.classList.contains('stamped-rewards-widget-item');
    });
  }

  function spendNeedsEnhance(widget) {
    if (!widget) return false;
    var items = spendItems(widget);
    var i;
    for (i = 0; i < items.length; i++) {
      var id = items[i].getAttribute('data-campaign-id') || '';
      if (!id || id.indexOf('{') !== -1) continue;
      if (!items[i].getAttribute('data-esn-reward') || items[i].getAttribute('data-esn-dollars') !== 'redeem-line') return true;
    }
    if (!memberIsLoggedIn(widget)) return false;
    if (customerPointBalance() == null) return true;
    for (i = 0; i < items.length; i++) {
      if (!SPEND_OFFERS[items[i].getAttribute('data-esn-reward')]) continue;
      if (!items[i].getAttribute('data-esn-affordable')) return true;
    }
    return false;
  }

  function enhanceSpend(widget) {
    var items = spendItems(widget);
    var i;
    for (i = 0; i < items.length; i++) {
      var id = items[i].getAttribute('data-campaign-id') || '';
      if (!id || id.indexOf('{') !== -1) continue;
      var key = rewardKey(items[i]);
      items[i].setAttribute('data-esn-reward', key);
      applySpendCopy(items[i], key);
    }
    if (widget.querySelector('[data-esn-reward]')) widget.classList.add('esn-spend-ready');
    applySpendAccess(widget);
  }

  function runSpend() {
    spendTimer = null;
    if (spendEnhancing) {
      scheduleSpend();
      return;
    }
    var widget = findSpendWidget();
    if (!spendNeedsEnhance(widget)) return;
    spendEnhancing = true;
    try {
      enhanceSpend(widget);
    } catch (error) {
      window.setTimeout(scheduleSpend, 500);
    } finally {
      spendEnhancing = false;
    }
  }

  function scheduleSpend() {
    window.clearTimeout(spendTimer);
    spendTimer = window.setTimeout(runSpend, 400);
  }

  function watchSpend(widget) {
    if (!widget || widget.dataset.esnSpendWatching === 'true') return;
    widget.dataset.esnSpendWatching = 'true';
    var observer = new MutationObserver(function () {
      if (!spendEnhancing) scheduleSpend();
    });
    observer.observe(widget, { childList: true, subtree: true });
    scheduleSpend();
  }

  function formatPoints(value) {
    var number = Number(String(value).replace(/,/g, ''));
    if (!isFinite(number)) return String(value);
    return number.toLocaleString('en-US');
  }

  function readPoints() {
    if (!window.StampedFn || typeof window.StampedFn.getDataRewards !== 'function') return null;
    if (typeof window.StampedFn.getLoggedInCustomer === 'function' && !window.StampedFn.getLoggedInCustomer()) return null;
    var data = window.StampedFn.getDataRewards();
    if (!data || !data.points || data.points.points == null || data.points.points === '') return null;
    return formatPoints(data.points.points);
  }

  function openLauncher() {
    if (window.StampedFn && typeof window.StampedFn.toggleRewardsModal === 'function') {
      window.StampedFn.toggleRewardsModal();
      return;
    }
    var launcher = document.querySelector('.stamped-launcher-button');
    if (launcher) launcher.click();
  }

  function initBannerPoints() {
    var root = document.querySelector('[data-esn-banner-points]');
    if (!root || root.dataset.esnBannerReady === 'true') return;
    root.dataset.esnBannerReady = 'true';

    var value = root.querySelector('[data-esn-points]');
    var button = root.querySelector('[data-esn-open-launcher]');
    var attempts = 0;

    if (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        openLauncher();
      });
    }

    function tick() {
      attempts += 1;
      var points = readPoints();
      if (points && value && value.textContent !== points) {
        value.textContent = points;
        value.removeAttribute('aria-busy');
        root.classList.add('is-ready');
      }
      if (attempts > 40) return;
      window.setTimeout(tick, 500);
    }

    document.addEventListener('stamped:rewards:init', tick);
    tick();
  }

  function scrollOffset() {
    var offset = 16;
    var header = document.querySelector('store-header');
    if (!header) return offset;
    var style = window.getComputedStyle(header);
    var sticky = style.position === 'sticky' || style.position === 'fixed' || header.getAttribute('data-is-sticky') === 'true';
    if (!sticky) return offset;
    var rect = header.getBoundingClientRect();
    if (rect.bottom > 0) offset = rect.bottom + 16;
    return offset;
  }

  function scrollToKind(kind) {
    var target = null;
    if (kind === 'redeem') target = document.querySelector('[data-widget-type="rewards-spendings-v2"]');
    if (kind === 'faq') target = document.querySelector('.cc-faq');
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset - scrollOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function memberDebugEnabled() {
    return !!document.querySelector('[data-esn-member][data-esn-debug="true"]');
  }

  function setMemberState(root, state) {
    var views = root.querySelectorAll('[data-esn-member-view]');
    var buttons = root.querySelectorAll('[data-esn-debug-state]');
    var i;
    root.setAttribute('data-esn-state', state);
    for (i = 0; i < views.length; i++) {
      if (views[i].getAttribute('data-esn-member-view') === state) views[i].removeAttribute('hidden');
      else views[i].setAttribute('hidden', '');
    }
    for (i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed', buttons[i].getAttribute('data-esn-debug-state') === state ? 'true' : 'false');
    }
    if (state === 'member') applyDebugPoints(root);
  }

  function applyDebugPoints(root) {
    var input = root.querySelector('[data-esn-debug-points]');
    var value = root.querySelector('[data-esn-member-view="member"] [data-esn-points]');
    if (!value) return;
    var typed = input && input.value !== '' ? formatPoints(input.value) : '';
    if (typed) {
      value.textContent = typed;
      value.removeAttribute('aria-busy');
      value.setAttribute('data-esn-debug-lock', 'true');
      return;
    }
    value.removeAttribute('data-esn-debug-lock');
    var real = readPoints();
    if (!real) return;
    value.textContent = real;
    value.removeAttribute('aria-busy');
  }

  function initMemberBar() {
    var roots = document.querySelectorAll('[data-esn-member]');
    if (!roots.length) return;
    var debugOn = memberDebugEnabled();
    var i;
    for (i = 0; i < roots.length; i++) {
      if (roots[i].dataset.esnMemberReady === 'true') continue;
      roots[i].dataset.esnMemberReady = 'true';
      roots[i].addEventListener('click', function (event) {
        var debugState = event.target.closest('[data-esn-debug-state]');
        if (debugState && this.contains(debugState)) {
          var next = debugState.getAttribute('data-esn-debug-state');
          setMemberState(this, next);
          try { sessionStorage.setItem('esn-member-debug-state', next); } catch (error) {}
          return;
        }
        var trigger = event.target.closest('[data-esn-scroll]');
        if (!trigger || !this.contains(trigger)) return;
        event.preventDefault();
        scrollToKind(trigger.getAttribute('data-esn-scroll'));
      });

      if (!debugOn) continue;
      var debug = roots[i].querySelector('[data-esn-member-debug]');
      var input = roots[i].querySelector('[data-esn-debug-points]');
      if (debug) debug.removeAttribute('hidden');
      try {
        var savedPoints = sessionStorage.getItem('esn-member-debug-points');
        var savedState = sessionStorage.getItem('esn-member-debug-state');
        if (input && savedPoints) input.value = savedPoints;
        if (savedState === 'guest' || savedState === 'member') setMemberState(roots[i], savedState);
      } catch (error) {}
      if (input) {
        input.addEventListener('input', function () {
          var root = this.closest('[data-esn-member]');
          try { sessionStorage.setItem('esn-member-debug-points', this.value); } catch (error) {}
          if (root && root.getAttribute('data-esn-state') === 'member') applyDebugPoints(root);
        });
      }
    }

    var value = document.querySelector('[data-esn-member] [data-esn-points]');
    if (!value || value.dataset.esnPointsWatching === 'true') return;
    value.dataset.esnPointsWatching = 'true';
    var attempts = 0;

    function tick() {
      attempts += 1;
      var points = readPoints();
      if (points && value.getAttribute('data-esn-debug-lock') !== 'true' && value.textContent !== points) {
        value.textContent = points;
        value.removeAttribute('aria-busy');
      }
      if (attempts > 40) return;
      window.setTimeout(tick, 500);
    }

    document.addEventListener('stamped:rewards:init', tick);
    tick();
  }

  function boot() {
    initBannerPoints();
    initMemberBar();
    watch(findWidget());
    watchVip(findVipWidget());
    watchSpend(findSpendWidget());
    document.addEventListener('stamped:rewards:init', function () {
      schedule();
      scheduleVip();
      scheduleSpend();
    });
    document.addEventListener('stamped:widget:rewards-earnings:loaded', schedule);
    document.addEventListener('stamped:widget:rewards-spendings:loaded', scheduleSpend);

    window.setInterval(function () {
      pollCount += 1;
      if (pollCount > 80) return;
      var widget = findWidget();
      var vipWidget = findVipWidget();
      var spendWidget = findSpendWidget();
      watch(widget);
      watchVip(vipWidget);
      watchSpend(spendWidget);
      if (!timer && needsEnhance(widget)) schedule();
      if (!vipTimer && vipNeedsEnhance(vipWidget)) scheduleVip();
      if (!spendTimer && spendNeedsEnhance(spendWidget)) scheduleSpend();
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
